import React from 'react'
import Header from './Header/Header'
import Profile from './Profile/Profile';
import Footer from './Footer/Footer';
import './Home.css';

function Home(props) {
    return (
        <div className="home-container" id={ props.id || ''}>
            <Header />
            <Profile />
            <Footer /> 
            <div className='icon'>
                <tr>
                    <td>
                    <a href=' https://www.linkedin.com/in/ashwani-kumar-jha-a15970213/' className='linkedin'><i className='linkdn'></i> LinkedIn </a>
                    </td>
                    <td>
                    <a href='https://github.com/ashwanijha8068' className='github'> <i className='gthub'></i>GitHub</a>
                    </td>
                </tr>
           
           
            
            
          </div>
        </div>
    )
}

export default Home;
